<template>
  <div>
    <h1 class="text-2xl mb-6">UTM Content</h1>
    <UtmContentFilters ref="utmContentFilters"></UtmContentFilters>
    <UtmContentSiteTotalsTable
      ref="utmContentSiteTotalsTable"
    ></UtmContentSiteTotalsTable>
    <UtmContentReportTable ref="utmContentReportTable"></UtmContentReportTable>
  </div>
</template>
<script>
import UtmContentReportTable from "@/components/acquisition/utm-content/tables/UtmContentReportTable.vue";
import UtmContentSiteTotalsTable from "@/components/acquisition/utm-content/tables/UtmContentSiteTotalsTable.vue";
import UtmContentFilters from "@/components/acquisition/utm-content/filters/UtmContentFilters.vue";
export default {
  name: "AcquiUtmContent",
  components: {
    UtmContentReportTable,
    UtmContentSiteTotalsTable,
    UtmContentFilters,
  },
};
</script>
<style></style>
